import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import * as moment from "moment";
import {
  BootstrapTable, TableHeaderColumn
} from "react-bootstrap-table";
import { Button, Classes, Dialog, FormGroup, H5, InputGroup, Popover, Switch, TextArea } from "@blueprintjs/core";
import { observable } from "mobx";
import { Pager } from "../utils/Pager";
import { IconButton } from "@mui/material";
import Draggable from "react-draggable";
import { AppIcon } from "../utils/AppIcon";
import { toast } from "react-toastify";


@observer
export class ReleasesPage extends React.Component<{}, {}> {
  obs = observable({
    open_visualiza_descricao: false,
    open_create: false as boolean,
    loading_save: false as boolean,
    preview_open: false as boolean,
    title: "" as string,
    description: "" as string,
    version: "" as string,
    id: "" as string,
    current_page: 1 as number,
    currentSteps: 1
  })

  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
    AppStore.setTitle("Histórico de Atualizações");
  }

  handlePageChange = async (page: number) => {

    await AppStore.handleIndexReleases(page);

    this.obs.current_page = page;

  };

  async handleCloseModalUpdates(version) {

    await AppStore.handleUpdatesModal(AppStore.obs1.usuario._id, version)

    if (AppStore.obs1.result_ok) {

      await AppStore.loadUsuario()

    }

  }

  handleOpenCreate = () => {
    this.obs.id = ""
    this.obs.title = ""
    this.obs.version = ""
    this.obs.description = ""
    this.obs.preview_open = false
    this.obs.open_create = true
  }

  handleCloseCreate = () => {
    this.obs.open_create = false
    this.obs.preview_open = false
    this.obs.title = ""
    this.obs.version = ""
    this.obs.description = ""
    this.obs.id = ""
  }

  handleSaveCreate = async () => {

    if (!this.obs.title) {
      toast.warn("Campo Título obrigatório.", {})
      return
    }

    if (!this.obs.version) {
      toast.warn("Campo Versão obrigatório.", {})
      return
    }

    if (!this.obs.description) {
      toast.warn("Campo Descrição obrigatório.", {})
      return
    }

    this.obs.loading_save = true

    let resp = await AppStore.handleCreateRelease(this.obs.title, this.obs.version, this.obs.description)

    this.obs.loading_save = false

    if (resp) {

      this.handleCloseCreate()

      await AppStore.handleIndexReleases(this.obs.current_page = 1)

    }

  }

  formatVersion = (version) => {

    if (!version) return 0

    return parseInt(version.replace(/\./g, ""))

  }

  handleViewDetalhes = (row: any) => {

    this.obs.description = row.description
    this.obs.version = row.version
    this.obs.title = row.title

    this.obs.open_visualiza_descricao = true

    if (this.formatVersion(row.version) > this.formatVersion(AppStore.obs1.usuario.version_update)) {

      this.handleCloseModalUpdates(row.version)

    }

  }

  handleEdit = (row: any) => {

    this.obs.description = row.description
    this.obs.title = row.title
    this.obs.version = row.version
    this.obs.id = row.id

    this.obs.preview_open = false
    this.obs.open_create = true

  }

  handleDelete = async (id: string) => {

    let resp = await AppStore.handleDeleteRelease(id)

    if (resp) {

      await AppStore.handleIndexReleases(this.obs.current_page = 1)

    }

  }

  handleSave = async () => {

    if (!this.obs.title) {
      toast.warn("Campo Título obrigatório.", {})
      return
    }

    if (!this.obs.version) {
      toast.warn("Campo Versão obrigatório.", {})
      return
    }

    if (!this.obs.description) {
      toast.warn("Campo Descrição obrigatório.", {})
      return
    }

    this.obs.loading_save = true

    let resp = await AppStore.handleEditRelease(this.obs.id, this.obs.title, this.obs.version, this.obs.description)

    this.obs.loading_save = false

    if (resp) {

      this.handleCloseCreate()

      await AppStore.handleIndexReleases(this.obs.current_page = 1)

    }

  }

  render() {

    let rows = AppStore.obs1.releases?.map(emp => {
      return ({
        id: (emp._id || emp.id),
        title: emp.title,
        version: emp.version,
        description: emp.description,
        new: emp.new,
        inserted_at: `${moment(emp.inserted_at).add(3, "hours").format("DD/MM/YY")} às ${moment(emp.inserted_at).add(3, "hours").format("HH:mm")}`
      })
    })

    const formatVisualizaDetalhes = (cell, row) => {

      return (<>
        <IconButton onClick={(e) => this.handleViewDetalhes(row)}>
          <img src="/images/view.png" width="18px" />
        </IconButton>

        {AppStore.obs1.usuario.admin
          ? <>
            <IconButton onClick={(e) => this.handleEdit(row)}>
              <img src="/images/edit.png" width="18px" />
            </IconButton>

            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <IconButton>
                <img src="/images/bin.png" width="18px" />
              </IconButton>
              <div>
                <H5>Confirmar exclusão?</H5>
                <p style={{ fontSize: 11 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="danger"
                    className={Classes.POPOVER_DISMISS}
                    onClick={(e) => this.handleDelete(row.id)}
                  >
                    Excluir
                  </Button>
                </div>
              </div>
            </Popover>
          </>

          : <></>}

      </>)

    }

    const formatTitle = (cell, row) => {

      if (row.new) {
        return (<div>
          {row.title}
          &nbsp;
          <span className="new-tag-nav-new">NOVO</span>
        </div>)
      }

      return row.title

    }

    return (
      <>

        <div className="dashboard-page">
          <MDBRow>
            <MDBCol md="12">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <p style={{ margin: 0 }}>
                  Abaixo listamos as todas as nossas notas de alterações já realizadas.
                </p>
                {AppStore.obs1.usuario.admin && <Button text="Criar Release" intent="primary" icon="plus" onClick={this.handleOpenCreate} />}
              </div>

              <BootstrapTable className="TableDefault historicoReleases" data={rows}>
                <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%"> # </TableHeaderColumn>
                <TableHeaderColumn dataFormat={formatTitle} width="70%">Titulo</TableHeaderColumn>
                <TableHeaderColumn dataField="version" width="20%">Versão</TableHeaderColumn>
                <TableHeaderColumn dataField="inserted_at" width="20%">Data Alteração</TableHeaderColumn>
                <TableHeaderColumn dataFormat={formatVisualizaDetalhes} width="10%">Ações</TableHeaderColumn>
              </BootstrapTable>
            </MDBCol>
          </MDBRow>

          <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
            <Pager
              currentPage={this.obs.current_page}
              totalCount={AppStore.obs1.releases_length}
              pageSize={10}
              onPageChange={this.handlePageChange}
            />
          </div>

        </div>

        <Dialog isOpen={this.obs.open_visualiza_descricao} onClose={() => this.obs.open_visualiza_descricao = false} className="modal-releases">

          <div style={{ padding: "0px 0px 15px 0px" }}>

            <div dangerouslySetInnerHTML={{ __html: this.obs.description }} />

          </div>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" intent="primary" onClick={() => this.obs.open_visualiza_descricao = false} />
          </div>

        </Dialog>

        {this.obs.open_create && (
          <div className="releases-floating-panel-backdrop" onClick={this.handleCloseCreate} />
        )}

        {this.obs.open_create && (
          <Draggable handle=".create-release-header">
            <div className="releases-floating-panel releases-floating-panel-create">
              <div className="create-release-header releases-panel-header releases-panel-header-draggable">
                <h2 className="titleSEFAZ modal-sefa">
                  {this.obs.id ? "Editar Release" : "Criar Release"}
                </h2>
                <Button
                  minimal
                  small
                  icon="cross"
                  onClick={this.handleCloseCreate}
                  disabled={this.obs.loading_save}
                />
              </div>

              <div className="releases-panel-body">

                <div className="releases-form-row">

                  <FormGroup className="form-group" label="Título" labelInfo="*" style={{ flex: 1 }}>
                    <InputGroup
                      type="text"
                      value={this.obs.title}
                      onChange={(e) => this.obs.title = e.target.value}
                      placeholder="Atualização do Sistema"
                    />
                  </FormGroup>

                  <FormGroup className="form-group" label="Versão" labelInfo="*" style={{ width: 180 }}>
                    <InputGroup
                      type="text"
                      value={this.obs.version}
                      onChange={(e) => this.obs.version = e.target.value}
                      placeholder="1.0.32"
                    />
                  </FormGroup>

                </div>

                <FormGroup
                  className="form-group"
                  label={
                    <div className="releases-description-label">
                      <span>Descrição (HTML) <span className="bp3-text-muted">*</span></span>
                      <Switch
                        alignIndicator="right"
                        label={this.obs.preview_open ? "Fechar pré-visualização" : "Visualizar"}
                        onClick={() => this.obs.preview_open = !this.obs.preview_open}
                      />
                    </div>
                  }
                >
                  <TextArea
                    value={this.obs.description}
                    onChange={(e) => this.obs.description = e.target.value}
                    fill
                    className="releases-description-textarea"
                    placeholder={'<div>\n  <p class="title-no-bottom">Atualização do Sistema</p>\n  <p>Conteúdo...</p>\n</div>'}
                  />
                </FormGroup>

              </div>

              <div className={`${Classes.DIALOG_FOOTER_ACTIONS} releases-panel-footer`}>
                <Button text="Cancelar" onClick={this.handleCloseCreate} disabled={this.obs.loading_save} />
                <Button
                  text="Salvar"
                  intent="primary"
                  onClick={this.obs.id ? this.handleSave : this.handleSaveCreate}
                  loading={this.obs.loading_save}
                  disabled={!this.obs.title || !this.obs.version || !this.obs.description}
                />
              </div>
            </div>
          </Draggable>
        )}

        {this.obs.open_create && this.obs.preview_open && (
          <Draggable handle=".releases-panel-header">
            <div className="releases-floating-panel releases-floating-panel-preview">
              <div className="releases-panel-header releases-panel-header releases-panel-header-draggable">
                <strong><AppIcon name="visibility" size={20} />&nbsp;Pré-visualização</strong>
                <Button
                  minimal
                  small
                  icon="cross"
                  onClick={() => this.obs.preview_open = false}
                />
              </div>
              <div className="releases-panel-body">
                <div dangerouslySetInnerHTML={{ __html: this.obs.description }} />
                {!this.obs.description && (
                  <p className="releases-preview-empty">
                    Digite o HTML no editor ao lado para visualizar aqui.
                  </p>
                )}
              </div>
            </div>
          </Draggable>
        )}

      </>
    );
  }
}

export default ReleasesPage;
